import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3 whitespace-nowrap">
              Browse Categories
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
              Shop by Category
            </h2>
            <p className="text-sm text-foreground-500 max-w-md mx-auto">
              Explore our curated collection of CSSBuy finds across 14 product categories — each with verified links and QC data.
            </p>
          </div>

          {/* Scrollable Grid */}
          <div className="overflow-x-auto pb-4 -mx-4 px-4">
            <div className="flex gap-4 md:gap-5" style={{ minWidth: 'max-content' }}>
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group flex-shrink-0 w-[200px] md:w-[220px] cursor-pointer"
                >
                  {/* Card */}
                  <div className="relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 group-hover:border-accent-300">
                    {/* Image */}
                    <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
                      <img
                        src={cat.image}
                        alt={`${cat.name} category - CSSBuy Spreadsheet`}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/10 transition-colors duration-300"></div>
                    </div>
                  </div>
                  {/* Label below card */}
                  <div className="mt-3 px-1">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 flex-shrink-0">
                        <i className={`${cat.icon} text-accent-600 text-xs`}></i>
                      </div>
                      <span className="text-sm font-semibold text-foreground-800 group-hover:text-foreground-950 transition-colors">
                        {cat.name}
                      </span>
                    </div>
                    <p className="text-xs text-foreground-400 mt-1 ml-8 whitespace-nowrap">
                      View on kaspreadsheet
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}